import React from 'react';
import { FourSquare } from 'react-loading-indicators';

function Loader() {

  return (
    <div className='model'>
      <FourSquare color="blue" size="medium" text="" textColor="" />
    </div>

  )
}

export default Loader;